// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

//@ constants
const { COMMONS } = require('constants/mortgageRequestHolderData');
const { MORTGAGE_PANEL } = require('constants/links');

// @ components
const MortgageRequestErrorCustom = require('components/mortgageRequest/mortgageRequestErrorCustom/mortgageRequestErrorCustom');

const MortgageRequestIssueSimpleNoteView = props => {
    const { immGlobalPosition } = props;
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText('mortgageRequestSimpleNoteUploaded-title'),
            url: ''
        }
    ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

    const title = formatText('mortgageRequestSimpleNoteIssue-title');
    const paragraph = formatText('mortgageRequestSimpleNoteIssue-paragraph');
    const paragraphPhone = formatText('mortgageRequestSimpleNoteIssue-paragraphPhone', [COMMONS.PRESTAMOS_PHONE]);
    const linkLabel = formatText('mortgageRequestSimpleNoteIssue-backToPanel');

    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('mortgageRequestSimpleNoteUploaded-title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-12">
                            <MortgageRequestErrorCustom
                                errorTitle={title}
                                goBackButtonLabel={linkLabel}
                                goBackButtonLink={MORTGAGE_PANEL}
                            >
                                <div>
                                    <p>{paragraph}</p>
                                    <p>{paragraphPhone}</p>
                                </div>
                            </MortgageRequestErrorCustom>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

MortgageRequestIssueSimpleNoteView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired
}

module.exports = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestIssueSimpleNoteView);
